import React from 'react'
import { Box } from '@chakra-ui/react'
import { PublicRoute } from '../components/Auth/ProtectedRoute'
import { LoginForm } from '../components/Auth/LoginForm'

export const LoginPage: React.FC = () => {
  return (
    <PublicRoute>
      <Box
        minH="100vh"
        bg="gray.50"
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={4}
      >
        <LoginForm />
      </Box>
    </PublicRoute>
  )
}

export default LoginPage 